import { Config } from '@customTypes/config'
import React, { Suspense } from 'react'

type Props = { config: Config }

const Widget = React.lazy(() => import('./Widget'))

export const Ui = (props: Props) => {
  return (
    <Suspense fallback={null}>
      <Widget config={props.config} />
    </Suspense>
  )
}
